import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { formatNumber } from '@angular/common';

@Pipe({
  name: 'customCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) public locale: string) { }

  transform(value: number, digits = 2): string {
    if (value) {
      return '€ ' + formatNumber(value, this.locale, `1.${digits}-${digits}`) + (digits === 0 ? ',-' : '');
    }
    return '';
  }

}
